/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const SupportPlanGet = {
  id: 'support-plan.get',
  tag: 'Common',
  summary: 'Support plans',
  description: 'Get all support plans',
  method: 'get',
  flags: { isAuthorized: true },
  route: () => `/support-plans`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              id: z.string(),
              name: z.string(),
              description: z.string(),
              isDefault: z.boolean(),
              price: z.number(),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
